import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const ParentsInfoChartsDataContext = createContext();

const ParentsInfoChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.PARENTS_INFO_LIVE_BIRTHS,
            url: 'governanceroom/dashboard/vitalstatistics/live-births/parents-info',
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  tenagerMothers: data?.indicators?.tenagerMothers ?? 0
              },
              motherRace: data?.motherRace ?? [],
              motherMaritalStatus: data?.motherMaritalStatus ?? [],
              motherAge: data?.motherAge ?? [],
              motherScholarity: data?.motherScholarity ?? [],
              fatherAge: data?.fatherAge ?? [],
              motherSeries: data?.motherSeries ?? []
          }
        : {
              indicators: {
                  tenagerMothers: 0
              },
              motherRace: [],
              motherMaritalStatus: [],
              motherAge: [],
              motherScholarity: [],
              fatherAge: [],
              motherSeries: []
          };

    return (
        <ParentsInfoChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ParentsInfoChartsDataContext.Provider>
    );
};

export default ParentsInfoChartsDataProvider;
